// extracted by mini-css-extract-plugin
module.exports = {"points_activity":"History_points_activity__LWpUw"};